import { useEffect } from 'react';
import { autoJsStoreUtils, isRealInAndroid } from '@droid/android';
import { PrivacyDialogDisplay } from './PrivacyDialogDisplay';
import { useState } from 'react';
import { IDispatcher, Log } from '@fanfanlo';

const LOG_TAG = '[EMC_STORE]'
const fileLog = new Log(false, 'PrivacyDialogAuto_file')
interface PrivacyDialogAutoProps {
  type: string;
  area: string;
  dispatcher?:IDispatcher
}
export const privacyDialogClosedEventType = "privacyDialogClosed"
interface IPrivacyInfo {
  agree: boolean;
  disagreeTime: number;
}

let autoOpened = false; // 用于标记是否已经自动弹出过隐私协议
/**
 * 自动逻辑组件 - 负责处理隐私协议的自动弹出逻辑
 * 包含原有的35-49行逻辑：检查用户是否已同意、是否在冷却期等
 */
export function PrivacyDialogAuto({ type, area, dispatcher }: PrivacyDialogAutoProps) {
  const uiLog = fileLog.sub(false, 'PrivacyDialogAuto_ui')
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    autoOpened = true; // 设置为已自动弹出
    setOpen(false);
    dispatcher?.dispatch('privacyDialogClosed');
  };

  // 原有的自动弹出逻辑 (35-49行)
  useEffect(() => {
    const effLog = uiLog.sub(false, 'setOpenEffect')
    console.log(`${LOG_TAG} PrivacyDialogAuto useEffect start, type=${type}, isRealInAndroid=${isRealInAndroid}`)

    // web中也可以调试
    const def: IPrivacyInfo = { agree: isRealInAndroid ? false : true, disagreeTime: 0 };
    console.log(`${LOG_TAG} PrivacyDialogAuto default value=${JSON.stringify(def)}`)

    const res = autoJsStoreUtils.read<IPrivacyInfo>(`privacy_${type}`, def);
    console.log(`${LOG_TAG} PrivacyDialogAuto read result=${JSON.stringify(res)}`)

    const value: IPrivacyInfo = res && 'agree' in res ? res : def;
    console.log(`${LOG_TAG} PrivacyDialogAuto final value=${JSON.stringify(value)}`)

    effLog.log('values def=', def);
    effLog.log('values res=', res);
    effLog.log('values value=', value);
    effLog.log('autoOpened=', autoOpened)

    if(autoOpened){
      //自动检测已经弹出过了就不再弹了
      console.log(`${LOG_TAG} PrivacyDialogAuto skip: autoOpened=true`)
      return;
    }
    // 不在Android环境中不弹出
    // if (!isRealInAndroid) {
    //   return;
    // }

    // 已经同意了，不弹出
    if (value.agree) {
      effLog.log('value.agree=', value.agree)
      console.log(`${LOG_TAG} PrivacyDialogAuto skip: already agreed`)
      return;
    }

    // 在冷却期内（拒绝后3天内），不弹出
    if (value.disagreeTime && value.disagreeTime != 0 && value.disagreeTime + 3 * 24 * 60 * 60 * 1000 > Date.now()) {
      effLog.log('value.disagreeTime', value.disagreeTime , value.disagreeTime != 0 , value.disagreeTime + 3 * 24 * 60 * 60 * 1000, Date.now())
      console.log(`${LOG_TAG} PrivacyDialogAuto skip: in cooldown period`)
      return;
    }

    effLog.log('setOpen=true')
    console.log(`${LOG_TAG} PrivacyDialogAuto setOpen=true, will show dialog`)
    // 满足条件，弹出隐私协议
    setOpen(true);
  }, [type]);

  return (
    <PrivacyDialogDisplay
      open={open }
      onClose={handleClose}
      type={type}
      area={area}
    />
  );
}
